(() => {
  angular.module('app').component('foreignerMySst6Header', {
    templateUrl: require('./foreignerMySst6Header.component.html'),
    controller: ForeignerMySst6HeaderController,
    controllerAs: 'vm',
    bindings: {
      isApplyTax: '=',
      toggleIsApplyTax: '&',
    }
  });

  function ForeignerMySst6HeaderController() {
    const vm = this;

    vm.hasGPTicketEnhancement = abp.setting.getBoolean(
      'Hms.Feature.GPTicketEnhancement'
    );

    vm.handleToggle = handleToggle;

    function handleToggle() {
      vm.toggleIsApplyTax();
    }
  }
})();